import React from 'react';
import { Input, InputProps, ReadOnlyField } from '@indigo-ag/component-module';

import { utils } from 'shared';

interface EditableTextFieldProps {
  label: string;
  value: string;
  readonly?: boolean;
}

export const EditableTextField: React.FunctionComponent<EditableTextFieldProps & InputProps> = ({
  label,
  value,
  readonly = false,
  ...inputProps
}) => {
  const labelTitle = utils.text.toTitleCase(label);

  return readonly ? (
    <ReadOnlyField label={labelTitle} value={value || '-'} />
  ) : (
    <Input
      label={labelTitle}
      value={value}
      name={`etf-${label.split(' ').join('-')}`}
      sizeVariant="slim"
      {...inputProps}
    />
  );
};
